import { KommmissionierungStrategy } from './kommmissionierung.strategy';
import { ArtikelMenge, LagerplatzInhalt } from '@softapps/lager/core';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';

export class MischpaletteStrategy implements KommmissionierungStrategy {
  begleitscheindruck: boolean;
  lagerplatzAuswahl: boolean;
  loadLagerplatzVorschlag: boolean;

  constructor(lagerplatzAuswahl: boolean) {
    this.lagerplatzAuswahl = lagerplatzAuswahl;
    this.loadLagerplatzVorschlag = true;
    this.begleitscheindruck = false;
  }

  getMaxMenge(
    lagerplatz: LagerplatzInhalt | undefined,
    artikelMenge: ArtikelMenge | undefined
  ): number {
    if (!lagerplatz || !artikelMenge) return 0;
    return artikelMenge.menge ?? 0;
  }

  getPalettenBegleitscheinMenge(auftrag: KommissionsauftragKopf): number {
    return auftrag.mischpalette ? 2 : 0;
  }
}
